import api from '../../store/config/api';
import { INTEGRATION_LIST as SCHEMA } from '../../schemas';

export const [
  GET_INTEGRATIONS,
  GET_INTEGRATIONS_REQUEST,
  GET_INTEGRATIONS_SUCCESS,
  GET_INTEGRATIONS_FAILURE
] = api.buildTypes('GET_INTEGRATIONS');

export function getIntegrations({ teamName, appName = '' }) {
  return {
    type: GET_INTEGRATIONS,
    payload: {
      url: `/teams/${teamName}/integrations?appName=${appName}`,
      schema: SCHEMA
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/integrations.js